module.exports = __webpack_public_path__ + "static/media/emotional-wb-home@3x.4e999829.png";